import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import styles from './Toggle.module.scss';
const Toggle = ({ checked, onChange }) => {
    return (_jsxs("label", Object.assign({ className: cn(styles.element) }, { children: [_jsx("input", { "data-testid": "toggle", className: styles.input, type: "checkbox", checked: checked, onChange: onChange, readOnly: !onChange, disabled: !onChange }), _jsx("span", { className: cn(styles.slider, checked && styles['isChecked']) })] })));
};
export default Toggle;
